import React, { Component } from 'react';
import Vas from '../../Vas';

import '../../css/CreatePayment.css';
import { LinkButton } from 'component-lib';

var moment = require('moment');
        moment().format();

class ChangePaymentSuccess extends Component
{
    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        
            return (<div
              className={"PaymentContainer"}
              >
              <div className={"form"}>
                <table>
                  <thead>
                    <tr>
                      <th colSpan={2}><h2>{Vas.Resources.Labels["ChangePaymentSuccess"]}</h2></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ width:'265px', fontSize:'14px', textAlign: 'right' }}>{Vas.Resources.Labels["BackTo"]}</td>
                      <td style={{ textAlign: 'left' }}>
                        <LinkButton
                        Text={Vas.Resources.Labels["PersonalDataLink"]}
                        Id={"LinkLogin"}
                        OnClick={()=>{Vas.GetView("CustomerCard", { Id :this.props.match.params.CustomerId }, true);}} /></td>
                    </tr>
                  </tbody>
                </table>                
                   
              </div>
            </div>
            );
    }
}
export default ChangePaymentSuccess;
